/**
 * Metering selectors (PX-W6.4). Straight projections — `daily`/`byAgent`
 * destructure with defaults at the render boundary, never in state.
 */

import type { MeteringAgentBreakdown, MeteringDailyPoint, RemainingBudget, UsageSummary } from './types'
import type { MeteringState } from './slices/meteringSlice'

interface WithMetering {
  metering: MeteringState
}

export const selectMeteringUsage = (s: WithMetering): UsageSummary | null => s.metering.usage
export const selectMeteringUsageLoading = (s: WithMetering): boolean =>
  s.metering.caches.usage.loading
export const selectRunBudget = (s: WithMetering): RemainingBudget | null => s.metering.remaining
export const selectRunBudgetMissing = (s: WithMetering): boolean => s.metering.remainingMissing
export const selectRunBudgetLoading = (s: WithMetering): boolean =>
  s.metering.caches.remaining.loading
export const selectMeteringError = (s: WithMetering) => s.metering.error

/** Shared EMPTY series — stable references (see hours/selectors.ts for why). */
const EMPTY_DAILY: MeteringDailyPoint[] = []
const EMPTY_BY_AGENT: MeteringAgentBreakdown[] = []

/** The loaded usage's daily series — EMPTY before load or on the other shapes. */
export const selectMeteringDaily = (s: WithMetering): MeteringDailyPoint[] =>
  s.metering.usage?.daily ?? EMPTY_DAILY

/** The loaded usage's per-agent series — EMPTY before load or on the other shapes. */
export const selectMeteringByAgent = (s: WithMetering): MeteringAgentBreakdown[] =>
  s.metering.usage?.byAgent ?? EMPTY_BY_AGENT
